import * as React from "react";
import { SplitterElementPosition, Splitter, SplitterDirection } from "azure-devops-ui/Splitter";
import { ObservableValue } from "azure-devops-ui/Core/Observable";

export default class SplitterExample extends React.Component<any, any> {
    private collapsed = new ObservableValue(false);

    public render() {
        const containerStyle = { height: "500px", width: "600px", display: "flex" };
        return (
            <div style={containerStyle}>
                <Splitter
                    collapsed={this.collapsed}
                    fixedElement={SplitterElementPosition.Near}
                    splitterDirection={SplitterDirection.Vertical}
                    initialFixedSize={300}
                    minFixedSize={100}
                    nearElementClassName="v-scroll-auto custom-scrollbar"
                    farElementClassName="v-scroll-auto custom-scrollbar"
                    onCollapsedChanged={collapsed => (this.collapsed.value = collapsed)}
                    onRenderNearElement={this._renderNearContent}
                    onRenderFarElement={this._renderFarContent}
                />
            </div>
        );
    }

    private _renderNearContent(): JSX.Element {
        return (
            <div style={{ padding: "16px" }}>
                This is content that may be collapsed. Drag the splitter left so that the width of
                this content is less than the minimum fixed-size width, and this content will be
                collapsed.
            </div>
        );
    }

    private _renderFarContent(): JSX.Element {
        return (
            <div style={{ padding: "16px" }}>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
                exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute
                irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
                pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia
                deserunt mollit anim id est laborum.
            </div>
        );
    }
}
